import React from 'react'

//CostType
const CostTypePage = React.lazy(() => import('pages/CostType/CostTypePage'));
const CostTypeAdd = React.lazy(() => import('pages/CostType/CostTypeAdd'));
//.end#CostType



const CostTypeRoutes = [
    // CostType
    {
        path: '/cost-type',
        exact: true,
        name: 'Danh sách loại chi phí',
        function: 'MD_COSTTYPE_VIEW',
        component: CostTypePage,
    },
    {
        path: '/cost-type/add',
        exact: true,
        name: 'Thêm mới',
        function: 'MD_COSTTYPE_ADD',
        component: CostTypeAdd,
    },
    {
        path: '/cost-type/detail/:id',
        exact: true,
        name: 'Chi tiết',
        function: 'MD_COSTTYPE_DETAIL',
        component: CostTypeAdd,
    },
    {
        path: '/cost-type/edit/:id',
        exact: true,
        name: 'Chỉnh sửa',
        function: 'MD_COSTTYPE_EDIT',
        component: CostTypeAdd,
    },
    // .end#CostType
]

export default CostTypeRoutes
